import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

type UnlinkRrmFromHazardDialogProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isUnlinking: boolean
}

export function UnlinkRrmFromHazardDialog({
  isOpen,
  onClose,
  onConfirm,
  isUnlinking,
}: UnlinkRrmFromHazardDialogProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className='sm:max-w-md' showCloseButton={!isUnlinking}>
        <DialogHeader>
          <DialogTitle>
            {t('riskReductionMeasuresLibraryPage.rrmDetail.unlinkDialog.title')}
          </DialogTitle>
        </DialogHeader>
        <p className='text-sm text-muted-foreground'>
          {t('riskReductionMeasuresLibraryPage.rrmDetail.unlinkDialog.message')}
        </p>
        <DialogFooter>
          <Button variant='outline' onClick={onClose} disabled={isUnlinking}>
            {t('common:actions.cancel')}
          </Button>
          <Button
            variant='destructive'
            onClick={onConfirm}
            disabled={isUnlinking}
          >
            {isUnlinking
              ? t(
                  'riskReductionMeasuresLibraryPage.rrmDetail.unlinkDialog.unlinking'
                )
              : t(
                  'riskReductionMeasuresLibraryPage.rrmDetail.unlinkDialog.confirm'
                )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
